<template>
  <div>
    <div class="container-table-striped">
      <div class="table-hover">
        <table class="table content-table-striped table-striped mb-5">
          <thead>
            <tr class="row global-thead-dark thead-property pl-1">
              <th class="col-2">
                Fecha
              </th>
              <th class="col-2">
                Tipo
              </th>
              <th class="col-2">
                Título
              </th>
              <th class="col-2">
                Comentario
              </th>
              <th class="col-4" />
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in items" :key="item.id" class="row pl-2">
              <td class="col-md-2">
                <span>{{ item.date }}</span>
              </td>
              <td class="col-md-2">
                <span>{{ item.type }}</span>
              </td>
              <td class="col-md-2">
                <span>{{ item.title }}</span>
              </td>
              <td class="col-md-2">
                <span>{{ item.comment }}</span>
              </td>
              <td class="col-md-4 text-center">
                <button
                  class="btn btn-dropdown-actions dropdown-toggle pt-1"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Acciones
                </button>
                <div class="dropdown-menu dropdown-menu-right pb-0">
                  <a class="drop-item" href="#">
                    <i class="fas fa-file-alt text-green pr-2" />
                    <span>Documentos</span>
                  </a>
                  <a class="drop-item" href="#">
                    <i class="fas fa-pencil-alt text-green pr-2" />
                    <span>Editar</span>
                  </a>
                  <a class="drop-item" href="#">
                    <i class="fas fa-times-circle text-red pr-2" />
                    <span>Eliminar</span>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <p v-if="items.length == 0" class="text text-danger">
          Favor de anejar el documento de tipo Minuta - Controversia
        </p>
      </div>
    </div>
    <div v-if="!isAddMode" class="text-center">
      <BoxIconButton
        title="Presione aquí para anejar documento"
        icon="fas fa-file-plus"
        @click="addDocument"
      />
    </div>
    <ControversyDocumentAdd
      v-if="isAddMode"
      :document-type-list="documentTypeList"
      @on-save="saveDocument"
    />
  </div>
</template>

<script>
import BoxIconButton from '@/components/pei/shared/BoxIconButton';
import ControversyDocumentAdd from './ControversyDocumentAdd';

export default {
  name: 'ControversyDocument',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    documentTypeList: {
      type: Array,
      default: () => [],
    },
    isAddMode: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    addDocument() {
      this.$emit('on-add-document');
    },
    saveDocument(item) {
      this.$emit('on-save-document', item);
    },
  },
  components: {
    BoxIconButton,
    ControversyDocumentAdd,
  },
};
</script>

<style scoped>
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}
</style>
